namespace GeniuzPOS.InitialData {
    export interface PsCustomerSurveyDtRow {
        ChoiceId?: number;
        SurveyCode?: string;
        LineNo?: number;
        Choice?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
        Status?: number;
    }

    export namespace PsCustomerSurveyDtRow {
        export const idProperty = 'ChoiceId';
        export const nameProperty = 'SurveyCode';
        export const localTextPrefix = 'InitialData.PsCustomerSurveyDt';
        export const lookupKey = 'InitialData.PsCustomerSurveyDt';

        export function getLookup(): Q.Lookup<PsCustomerSurveyDtRow> {
            return Q.getLookup<PsCustomerSurveyDtRow>('InitialData.PsCustomerSurveyDt');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';

        export declare const enum Fields {
            ChoiceId = "ChoiceId",
            SurveyCode = "SurveyCode",
            LineNo = "LineNo",
            Choice = "Choice",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate",
            Status = "Status"
        }
    }
}
